export const USER_REGISTER_SUCCESS_COOKIE_NAME = 'user_register_success';
export const STORE_CONNECTION_SUCCESS_COOKIE_NAME = 'store_connection_success';
export const EBAY_CANADA_REGISTRATION_COOKIE_NAME = 'ebay_ca_connect_start';
export const SHIPPO_LASTSEEN_COOKIE_NAME = 'shippo_last_seen';
